import { GetGridSettingsDeviceColumnStatusBaseValueConverter } from 'General/Resources/ValueConverters/GetGridSettingsDeviceColumnStatusBase';

export class GetGridSettingsDeviceColumnStatusValueConverter extends GetGridSettingsDeviceColumnStatusBaseValueConverter {

}